export default __webpack_public_path__ + "static/media/twitter.69585944.svg";